import React, { Fragment, useEffect } from 'react'
import queryString from 'query-string'
import cookies from 'browser-cookies'
import { Helmet } from 'react-helmet-async'
import { IconThemeProvider } from 'shared/ui/Icon'
import icons from '../ui/icons'
import { ThemeProvider } from 'shared/utils/ThemeState'
import theme from '../styles/theme'
import '../styles/all.scss'

// Will be overridden by CSS, which prevents the FOUC effect
// because icons can be large before resized by CSS
const embeddedStyles = `
  img[src$="svg"] { display: none; }
  `

function DocumentLayout({ children }) {
  useEffect(() => {
    const affiliateCode = queryString.parse(window.location.search)['a']
    if (affiliateCode) {
      cookies.set('reacttraining.affiliate', affiliateCode, { expires: 365 })
    }
  }, [])

  const metaDescription = 'React Corporate Workshops, Training, and Consulting'

  return (
    <Fragment>
      <Helmet htmlAttributes={{ lang: 'en', dir: 'ltr' }}>
        <title>React Training</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="description" content={metaDescription} />

        {/* development, staging, or production. Set in travis config */}
        <meta
          property="GATSBY_ACTIVE_ENV"
          content={process.env.GATSBY_ACTIVE_ENV || 'development'}
        />

        <meta property="og:title" content="ReactTraining.com" />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:image" content="https://reacttraining.com/images/logo-icon-512.png" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://reacttraining.com" />
        <meta property="og:site_name" content="ReactTraining.com" />

        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600;700&display=swap"
          rel="stylesheet"
        />
        
        <script src="https://js.stripe.com/v3/"></script>
      </Helmet>
      <style children={embeddedStyles} />
      <ThemeProvider theme={theme}>
        <IconThemeProvider icons={icons}>{children}</IconThemeProvider>
      </ThemeProvider>
    </Fragment>
  )
}

export default DocumentLayout
